<!-- requires 4 empty <div> tags to create animation -->
<div class="busy" [ngClass]="css">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
